module.exports = __webpack_public_path__ + "static/media/terese.760482e0.jpg";